import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Error: React.FC = () => {
  const navigate = useNavigate();

  //todo get french version using i18n => use translation
  return (
    <Result
      status="500"
      title="Something Wrong"
      subTitle="Sorry, something went wrong."
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/')
          }}
        >
          Reload
        </Button>
      }
    />
  );
};

export default Error;
